// eslint-disable-next-line no-restricted-imports
import type { OrderedMap } from '@gonfalon/immutable-shim/immutableShim';

import type { AccessToken } from '#utils/accessTokenUtils';

export const findServiceTokenById = (serviceTokens: OrderedMap<string, AccessToken>, id: string) =>
  serviceTokens.find((token) => token._id === id);
